import React from "react"
import { Link } from "react-router-dom"
import { appConstants } from "../../../../../constants/app_constants"

const PasswordUpdated = () => {
  return (
    <div className="password-update-sub-container">
      <div className="common-margin sub-text">
        You will be automatically re-directed <br></br>
        to the {`${appConstants.cName}`} login page!
      </div>
    </div>
  )
}

export default PasswordUpdated
